import { ClaimLossType } from '@eigtech/claims-v2-types'
import { XALossTypeEnumSchema } from '@eigtech/verisk-edi-interface-types'
import { startCase } from 'lodash-es'

// TODO: get loss type labels from carrier config API
const lossTypeLabelRecord: Record<ClaimLossType, string> = {
  [XALossTypeEnumSchema.enum['DRAIN BCK']]: 'Drain Backup',
  [XALossTypeEnumSchema.enum['ICE/SNOW']]: 'Ice/Snow',
}

export const getLossTypeLabel = (lossType: ClaimLossType) =>
  lossTypeLabelRecord[lossType] ??
  (lossType.toLocaleUpperCase() === lossType ? startCase(lossType.toLocaleLowerCase()) : lossType)
